<template>
  <router-link class="filter-link" :to="{ name: linkName, params: linkParams }"><slot></slot></router-link>
</template>

<script>
export default {
  name: "FilterLink",
  props: {
    linkName: {
      type: String,
      required: true
    },
    linkParams: Object
  }
}
</script>

<style lang="scss" scoped>

.filter-link {
  display: block;
  margin-right: 1rem;
  font-size: 0.875rem;
  line-height: 30px;
}
</style>
